const Theme = {
    primary: '#ff7c00',
    primaryHover: '#ff9b3d',
    alternative: '#23ffe3',
    light: '#ffff',
    darkerLight: '#f8f8f8',
    // dark: '#272838',
    dark: '#111111',
    gray: '#969696',
    medium: '#4d4d4d',

    roundCorners: '.5em',
    rounderCorners: '1em',
    shadow: '0 .1em .2em rgb(1,1,1,.2)',

    transitionDuration: '.3s',

    padding: '2rem',
    gridGap: '1rem',
    minSize: '2.5rem',
}

export default Theme;
